import styled from 'styled-components';
import { match } from 'ts-pattern';
import { BaseOption } from 'ui/selects';
import { InfoBadge } from 'ui/badge';
import { Goals16 } from 'ui/icons/aurora/16px/studio/Goals16';
import { colors, spacing } from 'ui/theme';

const BadgeContainer = styled.span`
  display: inline-flex;
  gap: ${spacing.quarter};
  margin-left: ${spacing.quarter};
  &&&& path {
    fill: ${colors.iconPrimary};
  }
`;

export const addGoalsToOptions = (
  options: BaseOption[],
  journeyEventName?: string,
  projectGoalsEventNames?: string[],
) => {
  return options.map((option) => {
    const isProjectEvent = !!projectGoalsEventNames?.includes(option.value);
    const isJourneyEvent = !!(journeyEventName && journeyEventName === option.value);
    const isBothProjectAndJourneyEvent = isProjectEvent && isJourneyEvent;

    const tooltipContent = match({
      isProjectEvent,
      isJourneyEvent,
      isBothProjectAndJourneyEvent,
    })
      .with(
        { isBothProjectAndJourneyEvent: true },
        () =>
          'This event is a part of project and journey goals and cannot be removed from this campaign.',
      )
      .with(
        { isProjectEvent: true },
        () => 'This event is a part of a project goal and cannot be removed from this campaign.',
      )
      .with(
        { isJourneyEvent: true },
        () => 'This event is a part of a journey and cannot be removed from this campaign.',
      )
      .otherwise(() => undefined);

    if (isJourneyEvent || isProjectEvent) {
      return {
        ...option,
        tooltipContent,
        isDisabled: true,
        Suffix: (
          <BadgeContainer>
            {isJourneyEvent && <InfoBadge>Journey</InfoBadge>}
            {isProjectEvent && <InfoBadge icon={<Goals16 />}>Goal</InfoBadge>}
          </BadgeContainer>
        ),
      };
    }

    return option;
  });
};
